export enum APISettingEnum{

  // Tracking
  DISABLE_POSITIONING = "disablePositioning",
  AUTO_TRACKING = "autoTracking",
  MSG_INTERVAL_TRACKING = "trackingModeInterval",
  GPS_SAT_CRITERIA = "gpsSatCriteria",



}
